export default "__VITE_ASSET__ocPwpYtn__"